import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer/footer";
import StepRoutes from "../../Routes/steps_routes";
import { FcGrid } from "react-icons/fc";
import PolyhouseFoundationDesigner from "./flatbedGrobg";
import PolyhouseDesigner from "./polyhouse_construction";
import PolyhouseFront from "./polyhouseFront";
import PolyhouseCenter from "./polyhouseCenter";
import PolyhouseSide from "./polyhouseSide";
import { useSelector } from "react-redux";

const ConstructDesigns = () => {
  let userData = useSelector((store) => store.login.user);

  let role = userData.Role;

  const [length, setLength] = useState(24); // along X
  const [width, setWidth] = useState(20); // along Y
  const [BASE_SCALE, setBASE_SCALE] = useState(24); // px per meter (constant scale)
  const [footingDiaM, setFootingDiaM] = useState(0.35); // visual marker only
  const [precision, setPrecision] = useState(2); // decimals in CSV
  const [showGrid, setShowGrid] = useState(true);
  const [showLabels, setShowLabels] = useState(true); // controls **block** labels only
  const [showOutline, setShowOutline] = useState(true);
  const [showBC, setShowBC] = useState(true);
  const [showHC, setShowHC] = useState(true);
  const [entryStartLabel, setEntryStartLabel] = useState(""); // HCn start for entry cabin
  const [hcPairs, setHCPairs] = useState([]);
  const [blockName, setBlockName] = useState([]);
  // System allocation (exact combos requested)
  const [flatbedPct, setFlatbedPct] = useState(50); // options: 0,25,50,75,100
  const [growPct, setGrowPct] = useState(50); // options: 0,25,50,75,100
  const [dutchPct, setDutchPct] = useState(0); // options: 0,25,50,75,100
  const [aframePct, setAframePct] = useState(0); // options: 0,25,50,75,100
  const [designOpn, setDesignOpn] = useState("opn1");
  // const [clientName, setClientName] = useState();

  const pctOptions = [0, 25, 50, 75, 100];

  useEffect(() => {
    const names = [];

    if (aframePct) {
      names.push(`${aframePct}% A-frame`);
    }
    if (flatbedPct) {
      names.push(`${flatbedPct}% Flat-Nft`);
    }
    if (growPct) {
      names.push(`${growPct}% Growbags`);
    }
    if (dutchPct) {
      names.push(`${dutchPct}% Dutch-Bucket`);
    }

    setBlockName(names); // update state
  }, [aframePct, dutchPct, growPct, flatbedPct]);
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title">
                  <FcGrid className="fs-2 me-1" />
                  Construction Designer
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className={`accordion-body pt-0`}>
                        <div className="row">
                          <div className=" items-end">
                            <label>
                              <span className="text-xs text-gray-600">
                                Length L (X)
                              </span>
                              <input
                                type="number"
                                step="0.1"
                                min={0.5}
                                value={length}
                                onChange={(e) =>
                                  setLength(Number(e.target.value))
                                }
                                className="mt-1 w-full rounded-xl border px-3 py-2"
                              />
                            </label>
                            <label>
                              <span className="text-xs text-gray-600">
                                Width W (Y)
                              </span>
                              <input
                                type="number"
                                step="0.1"
                                min={0.5}
                                value={width}
                                onChange={(e) =>
                                  setWidth(Number(e.target.value))
                                }
                                className="mt-1 w-full rounded-xl border px-3 py-2"
                              />
                            </label>

                            <div className="col-12">
                              <label className="col-span-2">Flat-Bed (%)</label>
                              <select
                                value={flatbedPct}
                                onChange={(e) => {
                                  setFlatbedPct(e.target.value);
                                }}
                                className="form-control mb-2"
                              >
                                <option value="">select %</option>
                                {pctOptions.map((opt, idx) => (
                                  <option key={idx} value={opt}>
                                    {opt}%
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="col-12">
                              <label className="col-span-2">Growbag (%)</label>
                              <select
                                value={growPct}
                                onChange={(e) => {
                                  setGrowPct(e.target.value);
                                }}
                                className="form-control mb-2"
                              >
                                <option value="">select %</option>
                                {pctOptions.map((opt, idx) => (
                                  <option key={idx} value={opt}>
                                    {opt}%
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="col-12">
                              <label className="col-span-2">A-frame (%)</label>
                              <select
                                value={aframePct}
                                onChange={(e) => {
                                  setAframePct(e.target.value);
                                }}
                                className="form-control mb-2"
                              >
                                <option value="">select %</option>
                                {pctOptions.map((opt, idx) => (
                                  <option key={idx} value={opt}>
                                    {opt}%
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="col-12">
                              <label className="col-span-2">
                                Dutch Bucket (%)
                              </label>
                              <select
                                value={dutchPct}
                                onChange={(e) => {
                                  setDutchPct(e.target.value);
                                }}
                                className="form-control mb-2"
                              >
                                {pctOptions.map((opt, idx) => (
                                  <option key={idx} value={opt}>
                                    {opt}%
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="col-12">
                              <label>Scale px/m</label>
                              <input
                                type="number"
                                step="0.1"
                                min={0.5}
                                value={BASE_SCALE}
                                onChange={(e) =>
                                  setBASE_SCALE(Number(e.target.value))
                                }
                                className="form-control mb-2"
                              />
                            </div>

                            <label>
                              <span className="text-xs text-gray-600">
                                Footing Ø (visual)
                              </span>
                              <input
                                type="number"
                                step="0.05"
                                min={0.05}
                                value={footingDiaM}
                                onChange={(e) =>
                                  setFootingDiaM(Number(e.target.value))
                                }
                                className="mt-1 w-full rounded-xl border px-3 py-2"
                              />
                            </label>
                            <label>
                              <span className="text-xs text-gray-600">
                                CSV Decimals
                              </span>
                              <input
                                type="number"
                                step={1}
                                min={0}
                                max={6}
                                value={precision}
                                onChange={(e) =>
                                  setPrecision(Number(e.target.value))
                                }
                                className="mt-1 w-full rounded-xl border px-3 py-2"
                              />
                            </label>
                            <label className="col-span-2">
                              <span className="text-xs text-gray-600">
                                Entry Cabin 4×4 m (choose starting HC)
                              </span>
                              <select
                                value={entryStartLabel}
                                onChange={(e) =>
                                  setEntryStartLabel(e.target.value)
                                }
                                className="mt-1 w-full rounded-xl border px-3 py-2"
                              >
                                <option value="">Select</option>
                                {hcPairs.map((p) => (
                                  <option
                                    key={p.startLabel}
                                    value={p.startLabel}
                                  >
                                    {p.startLabel}
                                  </option>
                                ))}
                              </select>
                              <div className="text-[10px] text-gray-500 mt-1">
                                Cabin spans HCn→HC(n+1), placed{" "}
                                <b>2 m inside</b> from the hockey border.
                              </div>
                            </label>
                            {/* <div className="col-12">
                              <label>Client Name</label>
                              <input
                                type="text"
                                value={clientName}
                                onChange={(e) => setClientName(e.target.value)}
                                className="form-control mb-2"
                              />
                            </div> */}
                            <label className="col-span-2">
                              <span className="text-xs text-gray-600">
                                Select Layout Option
                              </span>
                              <select
                                value={designOpn}
                                onChange={(e) => setDesignOpn(e.target.value)}
                                className="mt-1 w-full rounded-xl border px-3 py-2"
                              >
                                <option value="">Select</option>

                                <option value="opn1">Option 1</option>
                                <option value="opn2">Option 2</option>
                              </select>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={`accordion-body d-none d-md-block`}>
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <label>Bay Size (L (X))</label>
                          <select
                            type="number"
                            step="0.1"
                            min={0.5}
                            value={length}
                            onChange={(e) => setLength(Number(e.target.value))}
                            className="form-control mb-2"
                          >
                            <option value="">Select</option>
                            {[
                              8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56,
                              60, 64, 68, 72, 76, 80, 84, 88, 92, 96, 100, 104,
                              108, 112, 116, 120, 124, 128, 132, 136, 140, 144,
                            ].map((number) => (
                              <option key={number} value={number}>
                                {number} Mtr
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-12">
                          <label> Span Size (W (Y))</label>
                          <select
                            type="number"
                            step="0.1"
                            min={0.5}
                            value={width}
                            onChange={(e) => setWidth(Number(e.target.value))}
                            className="form-control mb-2"
                          >
                            <option value="">Select</option>
                            {[
                              12, 20, 28, 36, 44, 52, 60, 68, 76, 84, 92, 100,
                              108, 116, 124, 132, 140, 148, 156, 164, 172, 180,
                              188, 196, 204, 212, 220, 228, 236, 244, 252, 260,
                              268, 276,
                            ].map((number) => (
                              <option key={number} value={number}>
                                {number} Mtr
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-12">
                          <label className="col-span-2">Flat-Bed (%)</label>
                          <select
                            value={flatbedPct}
                            onChange={(e) => {
                              setFlatbedPct(e.target.value);
                            }}
                            className="form-control mb-2"
                          >
                            <option value="">select %</option>
                            {pctOptions.map((opt, idx) => (
                              <option key={idx} value={opt}>
                                {opt}%
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-12">
                          <label className="col-span-2">Growbag (%)</label>
                          <select
                            value={growPct}
                            onChange={(e) => {
                              setGrowPct(e.target.value);
                            }}
                            className="form-control mb-2"
                          >
                            <option value="">select %</option>
                            {pctOptions.map((opt, idx) => (
                              <option key={idx} value={opt}>
                                {opt}%
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-12">
                          <label className="col-span-2">A-frame (%)</label>
                          <select
                            value={aframePct}
                            onChange={(e) => {
                              setAframePct(e.target.value);
                            }}
                            className="form-control mb-2"
                          >
                            <option value="">select %</option>
                            {pctOptions.map((opt, idx) => (
                              <option key={idx} value={opt}>
                                {opt}%
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-12">
                          <label className="col-span-2">Dutch Bucket (%)</label>
                          <select
                            value={dutchPct}
                            onChange={(e) => {
                              setDutchPct(e.target.value);
                            }}
                            className="form-control mb-2"
                          >
                            {pctOptions.map((opt, idx) => (
                              <option key={idx} value={opt}>
                                {opt}%
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="col-12">
                          <label>Scale px/m</label>
                          <input
                            type="number"
                            step="0.1"
                            min={0.5}
                            value={BASE_SCALE}
                            onChange={(e) =>
                              setBASE_SCALE(Number(e.target.value))
                            }
                            className="form-control mb-2"
                          />
                        </div>

                        <div className="col-12">
                          <label>Footing Ø (visual)</label>
                          <input
                            type="number"
                            step="0.05"
                            min={0.05}
                            value={footingDiaM}
                            onChange={(e) =>
                              setFootingDiaM(Number(e.target.value))
                            }
                            className="form-control mb-2"
                          />
                        </div>
                        <div className="col-12">
                          <label>Entry Cabin (4×4m) Position</label>
                          <select
                            value={entryStartLabel}
                            onChange={(e) => setEntryStartLabel(e.target.value)}
                            className="form-control"
                          >
                            <option value="">Select</option>
                            {hcPairs?.map((p) => (
                              <option key={p.startLabel} value={p.startLabel}>
                                {p.startLabel}
                              </option>
                            ))}
                          </select>
                          <div className="text-gray-500 mt-1  mb-2">
                            Cabin spans HCn→HC(n+1), placed <b>2m inside</b>{" "}
                            from the hockey border.
                          </div>
                        </div>
                        {/* <div className="col-12">
                          <label>Client Name</label>
                          <input
                            type="text"
                            value={clientName}
                            onChange={(e) => setClientName(e.target.value)}
                            className="form-control mb-2"
                          />
                        </div> */}
                        <div className="col-12">
                          <label className="col-span-2">
                            <span className="text-xs text-gray-600">
                              Select Layout Option
                            </span>
                            <select
                              value={designOpn}
                              onChange={(e) => setDesignOpn(e.target.value)}
                              className="mt-1 w-full rounded-xl border px-3 py-2"
                            >
                              <option value="">Select</option>

                              <option value="opn1">Option 1</option>
                              <option value="opn2">Option 2</option>
                            </select>
                          </label>
                        </div>

                        <div className="col-12">
                          <label className="flex items-center gap-2 me-2 mt-1">
                            <input
                              type="checkbox"
                              checked={showGrid}
                              onChange={(e) => setShowGrid(e.target.checked)}
                            />{" "}
                            Grid
                          </label>
                          <label className="flex items-center gap-2 me-2 mt-1">
                            <input
                              type="checkbox"
                              checked={showLabels}
                              onChange={(e) => setShowLabels(e.target.checked)}
                            />{" "}
                            Block labels
                          </label>

                          <label className="flex items-center gap-2 me-2 mt-1">
                            <input
                              type="checkbox"
                              checked={showOutline}
                              onChange={(e) => setShowOutline(e.target.checked)}
                            />{" "}
                            Outline
                          </label>
                          <label className="flex items-center gap-2 me-2 mt-1">
                            <input
                              type="checkbox"
                              checked={showBC}
                              onChange={(e) => setShowBC(e.target.checked)}
                            />{" "}
                            BC (Big Column)
                          </label>
                          <label className="flex items-center gap-2 me-2 mt-1">
                            <input
                              type="checkbox"
                              checked={showHC}
                              onChange={(e) => setShowHC(e.target.checked)}
                            />{" "}
                            HC (Hockey)
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <PolyhouseDesigner
                  length={length}
                  BASE_SCALE={BASE_SCALE}
                  width={width}
                  entryStartLabel={entryStartLabel}
                  footingDiaM={footingDiaM}
                  precision={precision}
                  showGrid={showGrid}
                  showLabels={showLabels}
                  showOutline={showOutline}
                  showBC={showBC}
                  showHC={showHC}
                  blockName={blockName}
                />
                <hr className="m-0" />
                <PolyhouseFoundationDesigner
                  setHCPairs={setHCPairs}
                  length={length}
                  BASE_SCALE={BASE_SCALE}
                  width={width}
                  entryStartLabel={entryStartLabel}
                  footingDiaM={footingDiaM}
                  precision={precision}
                  showGrid={showGrid}
                  showLabels={showLabels}
                  showOutline={showOutline}
                  showBC={showBC}
                  showHC={showHC}
                  flatbedPct={flatbedPct}
                  growPct={growPct}
                  dutchPct={dutchPct}
                  aframePct={aframePct}
                  blockName={blockName}
                  designOpn={designOpn}
                  // clientName={clientName}
                  role={role}
                />
                <hr className="m-0" />
                <PolyhouseFront
                  length={length}
                  width={width}
                  BASE_SCALE={BASE_SCALE}
                />
                <hr className="m-0" />
                <PolyhouseCenter
                  length={length}
                  width={width}
                  BASE_SCALE={BASE_SCALE}
                />
                <hr className="m-0" />
                <PolyhouseSide
                  length={length}
                  width={width}
                  BASE_SCALE={BASE_SCALE}
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ConstructDesigns;
